<template>
  <div class="reply-box-v2__actions-end">
    <div class="end-icon-group">
      <button
        v-if="showAudioRecorderButton"
        v-tooltip="$t('CONVERSATION.REPLYBOX.TIP_AUDIORECORDER_ICON')"
        type="button"
        class="action-icon-btn"
        :class="!isRecordingAudio ? 'text-gray-500' : 'text-red-500'"
        title="Record audio"
        @click="$emit('toggle-audio-recorder')"
      >
        <span class="material-symbols-outlined">
          {{ !isRecordingAudio ? 'mic' : 'mic_off' }}
        </span>
      </button>
      <button
        v-if="!isPrivateMode && hasInboxPermission('Inbox delay message')"
        type="button"
        class="action-icon-btn"
        title="Schedule send"
        :disabled="isSendButtonDisabled"
        @click="toggleDelayModal"
      >
        <span class="material-symbols-outlined">alarm</span>
      </button>
      <woot-modal :show.sync="showDelayModal" :on-close="hideDelayModal">
        <delay-message-modal
          :hours="delayOptions"
          :last-message-time="lastMessageTime"
          @set-delay="setDelay"
          @close="hideDelayModal"
        />
      </woot-modal>
    </div>
    <button
      class="send-btn"
      :class="{ 'send-btn--active': !isSendButtonDisabled }"
      :disabled="isSendButtonDisabled"
      @click="$emit('send')"
    >
      <span class="material-symbols-outlined send-icon">send</span>
      <span class="send-label">{{ $t('CONVERSATION.REPLYBOX.SEND') }}</span>
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import inboxMixin from 'shared/mixins/inboxMixin';
import DelayMessageModal from 'dashboard/components/widgets/modal/DelayMessageModal';

export default {
  name: 'RightToolbar',
  components: { DelayMessageModal },
  mixins: [hasPermissionMixin, inboxMixin],
  props: {
    showAudioRecorderButton: { type: Boolean, default: false },
    isRecordingAudio: { type: Boolean, default: false },
    isSendButtonDisabled: { type: Boolean, default: false },
    inboxId: { type: Number, default: null },
    isPrivateMode: { type: Boolean, default: false },
  },
  data() {
    return {
      showDelayModal: false,
      delayOptions: Array.from({ length: 24 }, (_, i) => i + 1),
    };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.inboxId);
    },
    lastMessageTime() {
      return this.isOnlineWaInboxV2
        ? this.currentChat.last_incoming_message_time
        : null;
    },
  },
  methods: {
    toggleDelayModal() {
      if (this.isSendButtonDisabled) return;
      this.showDelayModal = !this.showDelayModal;
    },
    hideDelayModal() {
      this.showDelayModal = false;
    },
    setDelay(hours) {
      this.$emit('set-delay', hours);
    },
  },
};
</script>
<style lang="scss" scoped>
.reply-box-v2__actions-end {
  display: flex;
  align-items: center;
  gap: 8px;
}

.end-icon-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.send-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  background: #e5e7eb;
  cursor: not-allowed;
  transition: background 0.15s ease, color 0.15s ease;

  .send-icon {
    font-size: 20px;
    line-height: 1;
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20;
    color: #9ca3af;
  }

  .send-label {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: #9ca3af;
  }

  &--active {
    background: #2abb7f;
    cursor: pointer;

    .send-icon,
    .send-label {
      color: #ffffff;
    }

    &:hover {
      background: #23a870;
    }
  }
}
/* Action icon button (toolbar icons) */
.action-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  border-radius: 4px;
  transition: background 0.15s ease, color 0.15s ease;

  .material-symbols-outlined {
    font-size: 24px;
    line-height: 1;
    color: #6b7280;
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20;
  }

  &:hover {
    background: #f3f4f6;
    color: #374151;
  }

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;

    .material-symbols-outlined {
      @apply text-gray-400;
    }
  }

  /* AI button */
  &--ai {
    width: 32px;
    height: 32px;
    background: #f0fdf4;
    border: 1px solid #e3ef26;
    border-radius: 4px;
    box-shadow: 0px 1px 8px 0px rgba(221, 221, 221, 0.25);
    color: #15803d;

    &:hover {
      background: #dcfce7;
      color: #166534;
    }
  }
}
</style>
